import { FormControl, InputLabel, makeStyles, MenuItem, Select } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles({
  label: {
    "& .MuiInputBase-input": {
      fontWeight: "bold"
    },
    "& .MuiFormLabel-root": {
      color: "#ffffff"
    },
    "& .MuiInputBase-root": {
      color: "#ffffff"
    },
    "& .MuiSelect-icon": {
      color: "#ffffff"
    }
  },
});

const MySelect = (props) => {
  const { handleChange, value, label, style, datas } = props;
  const classes = useStyles();

  return (
    <FormControl style={style} className={!props.classStyle ? classes.label : ""}>
      <InputLabel margin="dense">{label}</InputLabel>
      <Select value={value} onChange={(e, v) => handleChange(v.props)} label={label} disabled={props.disabled}>
        {
          datas.map((d) => {
            if (d.value !== null && d.label !== null) {
              return (
                <MenuItem value={d.value} key={d.value}><b>{d.label}</b></MenuItem>
              );
            }
          })
        }
      </Select>
    </FormControl>
  );

};

export default MySelect;